import * as React from "react";
import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Input from "@amzn/awsui-components-react/polaris/input";
import Button from "@amzn/awsui-components-react/polaris/button";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";

interface Props {
  profileId: string;
  onChange: (profileId: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
}

class ProfileLookupSection extends React.Component<Props> {
  render() {
    const { profileId, onChange, onSubmit, isLoading } = this.props;

    return (
      <Container header={<Header variant="h3">Profile Lookup</Header>}>
        <form onSubmit={(e) => { e.preventDefault(); if (profileId.trim()) onSubmit(); }}>
          <SpaceBetween size="xs" direction="horizontal">
            <FormField label="Health Profile ID">
              <div style={{ minWidth: 500 }}>
                <Input
                  value={profileId}
                  onChange={({ detail }) => onChange(detail.value)}
                  placeholder="amzn1.pharmacy.profile.id...."
                />
              </div>
            </FormField>
            <FormField label="&nbsp;">
              <Button
                variant="primary"
                formAction="submit"
                loading={isLoading}
                disabled={!profileId.trim()}
              >
                Look Up
              </Button>
            </FormField>
          </SpaceBetween>
        </form>
      </Container>
    );
  }
}

export default ProfileLookupSection;
